import { render } from "./ForSale.vue?vue&type=template&id=6089b9e6&scoped=true"
import script from "./ForSale.vue?vue&type=script&lang=js"
export * from "./ForSale.vue?vue&type=script&lang=js"

import "./ForSale.vue?vue&type=style&index=0&id=6089b9e6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6089b9e6"

export default script